import cronstrue from 'cronstrue';

export function isCronNotMoreFrequentThanOnceADay(
	cronExpression: string
): boolean {
	const parts: string[] = cronExpression.trim().split(/\s+/);

	// Ensure the cron expression has either 5 or 6 parts
	if (parts.length < 5 || parts.length > 6) {
		throw new Error('Invalid cron expression');
	}

	const minuteField: string = parts.length === 6 ? parts[1] : parts[0];
	const hourField: string = parts.length === 6 ? parts[2] : parts[1];

	// If either the minute or the hour field is '*', the job is more frequent than once a day
	if (minuteField === '*' || hourField === '*') {
		return false;
	}

	// Function to check for ranges or intervals in the field
	const hasMultipleExecutions = (field: string): boolean => /-|\//.test(field);

	// Check if minute or hour fields contain ranges or intervals
	if (hasMultipleExecutions(minuteField) || hasMultipleExecutions(hourField)) {
		return false;
	}

	// The cron expression does not represent a schedule more frequent than once a day
	return true;
}

export function isValidCronExpression(cronExpression: string): boolean {
	if (cronExpression.split(' ').length !== 5) {
		return false;
	}

	try {
		cronstrue.toString(cronExpression);
		return true;
	} catch (error) {
		return false;
	}
}

export function isValidCron(
	cronExpression: string,
	allowFrequentSyncs: boolean
): boolean {
	if (allowFrequentSyncs) {
		return isValidCronExpression(cronExpression);
	}

	return (
		isValidCronExpression(cronExpression) &&
		isCronNotMoreFrequentThanOnceADay(cronExpression)
	);
}

export function cronValidationMessage(
	cronExpression: string,
	allowFrequentSyncs: boolean
): string {
	if (!cronExpression) {
		return '';
	}

	if (!isValidCronExpression(cronExpression)) {
		return 'Invalid cron expression. Please refer to crontab.guru for help';
	}

	if (
		!isCronNotMoreFrequentThanOnceADay(cronExpression) &&
		!allowFrequentSyncs
	) {
		return 'Cron expression must be daily or less frequent';
	}

	return '';
}

export function getCronExpression(
	frequency: string,
	day: string,
	hour: string
): string {
	if (frequency === 'weekly') {
		return `0 ${hour} * * ${day}`;
	}

	if (frequency === 'daily') {
		return `0 ${hour} * * *`;
	}

	if (frequency === 'hourly') {
		return `0 * * * *`;
	}

	return `0 0 * * 6`;
}
